import { Injectable } from '@angular/core';
import { ApiBaseService } from './entities/api-base.service';

type ReaderAction = 'handheld' | 'epclist' | 'status' | 'events';

/**
 * Lectores RFID de Jetstream.
 *
 * El navegador ya NO llama a api.jetstreamrfid.com ni conoce la AccessKey:
 * le pide la lectura a nuestro API (POST /rfidReader/read), que tiene la llave
 * en el servidor y valida el permiso del usuario. Las firmas y lo que devuelve
 * cada método son los mismos que antes (la respuesta cruda de Jetstream).
 */
@Injectable({ providedIn: 'root' })
export class JetstreamService extends ApiBaseService<any> {
  constructor() { super('rfidReader'); }

  private async read(action: ReaderAction, device = ''): Promise<any> {
    const r: any = await this.request<any>('rfidReader/read', 'POST', { action, device });
    return r?.data?.[0]?.result ?? null;
  }

  /** Eventos del handheld de quirófano. */
  scanning(_deviceName: string): Promise<any> { return this.read('handheld'); }

  /** Lista de EPCs que ve un lector fijo. */
  scan(deviceName: string): Promise<any> { return this.read('epclist', deviceName); }

  /** Estado del lector. */
  status(deviceName: string): Promise<any> { return this.read('status', deviceName); }

  /** Eventos de comando completado (EPCs encontrados). */
  getEPC(deviceName: string): Promise<any> { return this.read('events', deviceName); }
}
